import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-user-role-cell',
  standalone: true,
  imports: [NgIf],
  template: `
    <span class="role-badge" [class.role-admin]="data?.role === 'ADMIN'">{{ data?.roleLabel || '—' }}</span>
    <div *ngIf="data?.mainAccount" class="role-hint">Dirigeant principal</div>
  `,
  styles: [`
    .role-badge {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 600;
      background: #eef2f7;
      color: #0b3954;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: break-word;
      line-height: 1.3;
    }
    .role-admin { background: #0b3954; color: #fff; }
    .role-hint { font-size: 11px; color: #6b7280; margin-top: 2px; }
  `],
})
export class UserRoleCellComponent {
  @Input() data: any;
  @Input() column: any;
}
